<template>
    <CTags class="CSearchTags" v-bind="$attrs" @tag-click="handleTagClick" />
</template>

<script setup lang="ts">
import CTags from '@/components/ui/CTags.vue'
import { appendValueToQueryParam } from '@/utils/query'
import { useRoute, useRouter } from 'vue-router'

interface Props {
    querySearchParam?: string
    searchRouteName?: string
    append?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    querySearchParam: 'hashtag',
    searchRouteName: 'vysledky-vyhladavania',
    append: false
})

const route = useRoute()
const router = useRouter()

const handleTagClick = async (tag: string) => {
    try {
        const query = props.append
            ? appendValueToQueryParam(route.query, props.querySearchParam, tag)
            : {
                  ...route.query,
                  [props.querySearchParam]: tag
              }

        await router
            .push({
                name: props.searchRouteName,
                query
            })
            .catch((err) => {
                console.error('Navigation failed:', err)
            })
    } catch (error) {
        console.error('Navigation error:', error)
    }
}
</script>
